import * as _ from 'lodash';

export namespace EntityCollection {
  export type SchemaContract<T> = {
    [id: string]: T;
  };

  export function toModel<T, U>(
    collectionContract: SchemaContract<T> | null,
    translation: (id: string, schemaContract: T) => U
  ): U[] {
    if (!collectionContract) {
      return [];
    }
    return _.keys(collectionContract).map((id) =>
      translation(id, collectionContract[id])
    );
  }
}
